import timeFieldComponentUrl from './timeFieldComponent.html';
class TimeFieldCtrl {
  constructor(Authentication, ShiftUtils, Utils, dateFilter, toTimeFilter, $attrs, $scope) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      ShiftUtils,
      Utils,
      dateFilter,
      toTimeFilter,
      $attrs,
      $scope,
    });

    this.isEndTime = 'startTimeCounterpart' in $attrs;
    this.isStartTime = 'endTimeCounterpart' in $attrs;

    $scope.$watch('ctrl.date', this._refreshHourOptions.bind(this));
  }

  $onInit() {
    const instance = this;
    this._refreshHourOptions();
    this._datepickerOptions = {};

    if (this.defaultDate) {
      Object.defineProperty(this._datepickerOptions, 'initDate', {
        get() {
          return instance.defaultDate;
        },
      });
    }

    if (this.isEndTime) {
      Object.defineProperty(this._datepickerOptions, 'minDate', {
        get() {
          return instance.startTimeCounterpart;
        },
      });
    }

    if (!('autocorrectDate' in this.$attrs)) {
      this.autocorrectDate = true; // default
    }
  }

  $onChanges({ defaultDate }) {
    if (defaultDate) {
      this._refreshHourOptions();
    }
  }

  get datepickerOptions() {
    return this._datepickerOptions;
  }

  get scrollToSelected() {
    return this.date || this.startTimeCounterpart || this.defaultDate;
  }

  scrollToCompare(date, optionIndex) {
    const optionDate = this.hourOptions[optionIndex].value;
    return Math.abs(date - optionDate);
  }

  _shouldCorrectEndTime() {
    return (
      this.isStartTime &&
      this.endTimeCounterpart &&
      this.date &&
      this.endTimeCounterpart < this.date
    );
  }

  dateChanged(fromDatepicker) {
    if (fromDatepicker && !this.time) {
      this.defaultDate = this.date;
      this.date = undefined;
      this._refreshHourOptions();
      return;
    }

    this._refreshHourOptions();

    if (this.autocorrectDate) {
      if (this._shouldCorrectEndTime()) {
        this.endTimeCounterpart = this._getCorrectEndTime(this.date, this.endTimeCounterpart);
      }

      if (
        this.isEndTime &&
        this.date &&
        this.startTimeCounterpart &&
        this.date < this.startTimeCounterpart
      ) {
        this.date = this._getCorrectEndTime(this.startTimeCounterpart, this.date);
      }
    }
  }

  hourClicked(hour) {
    this.date = hour.value;
    this.dateChanged();

    if (this.form) {
      this.form.$setDirty();
    }
  }

  _refreshHourOptions() {
    if (this.withDatePicker) {
      const { visibleHoursStart, visibleHoursEnd } = this.Authentication.user.orgSettings;
      const { visibleStart } = this.Utils.getVisibleHoursBoundaries(
        visibleHoursStart,
        visibleHoursEnd,
        this.date || this.defaultDate
      );
      this.hourOptions = this.Utils.getHourOptions(
        visibleStart,
        false,
        visibleStart.getHours(),
        visibleStart.getMinutes()
      ).map((item) => {
        item.label = this.toTimeFilter(item.label);
        return item;
      });
    } else {
      const { startHourOptions, endHourOptions } = this.Utils.getShiftHourOptions(
        { dtstart: this.date || this.defaultDate },
        this.Authentication.user.orgSettings
      );
      this.hourOptions = this.isEndTime ? endHourOptions : startHourOptions;
    }

    if (!this.date) {
      this.time = '';
      return;
    }

    const timeParsed = new Date(
      this.dateFilter(this.date, 'yyyy/MM/dd ') + this.Utils.parseTimeString(this.time)
    );

    if (timeParsed.getTime() !== this.date.getTime()) {
      this.time = this.toTimeFilter(this.date);
    }
  }

  _getCorrectEndTime(startTime, endTime) {
    let result;
    const endTimeHours = this.Utils.formatTime(endTime, false, true);
    result = this.Utils.dateFromHours(endTimeHours, startTime);
    if (result - startTime < 0) {
      result = this.Utils.addDays(result, 1);
    }

    return result;
  }
}

export default {
  bindings: {
    label: '@?',
    focusOnLabel: '@',
    date: '=',
    defaultDate: '<?',
    startTimeCounterpart: '=?',
    endTimeCounterpart: '=?',
    autocorrectDate: '<',
    isRequired: '<?',
    ngDisabled: '<?',
    withDatePicker: '<?',
    placeholder: '@?',
    hideDropdownArrow: '<?',
    narrow: '<?',
  },
  require: {
    form: '?^form',
  },
  templateUrl: timeFieldComponentUrl,
  controllerAs: 'ctrl',
  controller: TimeFieldCtrl,
};
